class Privilege {
  constructor(feature, component) {
    this.feature = feature;
    this.component = component;
  }

  getPrivilegeKey() {
    return `${this.feature}_${this.component}`;
  }

  getComponent() {
    return this.component;
  }
}

const Privileges = {
  ADMIN_OVERVIEW: new Privilege("admin", "overview"),
  CP_OVERVIEW: new Privilege("commissioningprocedure", "overview"),
  CRM_CRM_OVERVIEW: new Privilege("crmmanagement", "crm_overview"),
  DEVICES_DASHBOARD: new Privilege("devices", "dashboard"),
  DEVICES_DEVICES: new Privilege("devices", "devices"),
  DEVICES_GENERAL: new Privilege("devices", "general"),
  DEVICES_LOG: new Privilege("devices", "log"),
  DEVICES_METERING: new Privilege("devices", "metering"),
  DEVICES_OVERVIEW: new Privilege("devices", "overview"),
  DEVICES_SCHEMATIC: new Privilege("devices", "schematic"),
  FIRMWARES_OVERVIEW: new Privilege("firmwares", "overview"),
  PARTNER_COMPANY_OVERVIEW: new Privilege("management", "partner_companies"),
  UM_MANAGE_PRIVILEGES: new Privilege("usermanagement", "manageprivileges"),
  UM_MANAGE_USERS: new Privilege("usermanagement", "manageusers"),
  PROFILE_OVERVIEW: new Privilege("userprofile", "overview"),
  EARLY_ACCESS: new Privilege("early_access", "early_access"),
};

Object.freeze(Privileges);

export default Privileges;
